<template>
  <component :is="childComponentName"></component>
</template>
<script>
import './style.scss'
import ConfirmNew from './components/confirm/new'
import { isNullOrEmpty, isTrue } from '@/utils'
import { E_ORDER_TYPE } from '@/config'
import jsCookie from 'js-cookie'

export default {
  data() {
    const {
      query: { isOld = false, ruleId, ruleType, comeFrom = '' }
    } = this.$route

    let childComponentName = 'ConfirmNew'
    if (
      isTrue(isOld) ||
      (!isNullOrEmpty(ruleId) && +ruleType === E_ORDER_TYPE.GROUP_BUY)
    ) {
      childComponentName = 'ConfirmOld'
    }
    if (comeFrom === 'scan-buy') {
      childComponentName = 'ScanBuyConfirm'
    } else if (comeFrom === 'scan-buy-photo') {
      childComponentName = 'ScanBuyPhotoConfirm'
    }
    return {
      childComponentName
    }
  },
  components: {
    ConfirmNew,
    ConfirmOld: () => import('./components/confirm/old'),
    ScanBuyConfirm: () => import('./components/confirm/scan-buy-confirm'),
    ScanBuyPhotoConfirm: () =>
      import('./components/confirm/scan-buy-photo-confirm')
  },
  created() {
    // 优先取入参uid skey 微信内每次都重新登录
    if (this.$$getDevice() != 'weixin') {
      const { uid = '', skey = '' } = this.$route.query
      if (uid && skey) {
        jsCookie.set('uid', uid, { domain: '.cekid.com' })
        jsCookie.set('skey', skey, { domain: '.cekid.com' })
      }
    }
  },
  mounted() {
    this.$$allowRefreshOrShare(false, false)
  }
}
</script>
<style lang="scss" scoped></style>
